import { useAccount } from "@qw/auth";
import { INTERNAL_ROLES, PRODUCT_EDIT_ROLES } from "@qw/qw-common";
import { Outlet } from "react-router";
import { AppNav } from "@/app/app-nav";
import { ResizableChatLayout } from "@/chat/resizable-chat-layout";
import { NewCarrierButton } from "./new-carrier-button";
import { NewProductButton } from "./new-product-button";

export const ProductsLayout = () => {
  const { user } = useAccount();
  const canEditProducts = user.roles.some((role: string) => (PRODUCT_EDIT_ROLES as readonly string[]).includes(role));
  const canManageResources = user.roles.some((role: string) => (INTERNAL_ROLES as readonly string[]).includes(role));

  return (
    <>
      <AppNav>
        {canEditProducts && <NewProductButton />}
        {canManageResources && <NewCarrierButton />}
      </AppNav>
      <main className="flex flex-auto overflow-hidden">
        <ResizableChatLayout autoSaveId="products-chat-panels">
          <Outlet />
        </ResizableChatLayout>
      </main>
    </>
  );
};
